export default __webpack_public_path__ + "static/media/new-4.090f59ae.png";